// extracted by mini-css-extract-plugin
export default {"root":"ModalIframeButton_root__QnV6G","closeButton":"ModalIframeButton_closeButton__vrN9c","modal":"ModalIframeButton_modal__aJA09"};